// extracted by mini-css-extract-plugin
export default {"ContainerPai":"SecaoComentarios_ContainerPai__Pj1jP","MinhaSwiper":"SecaoComentarios_MinhaSwiper__pCxWD"};